import BlockEmbed from './BlockEmbed.js';
import ExternalizeLinks from './ExternalizeLinks.js';
import RenderInlineCode from './RenderInlineCode.js';
import ListItemNumbering from './ListItemNumbering.js';
import RenderCodeBlock from './RenderCodeBlock.js';
import SanitizeHTML from './SanitizeHTML.js';
import StyleLists from './StyleLists.js';
import TableOfContents from './TableOfContents.js';
import HTMLComments from './HTMLComments.js';
import ExpandCollapse from './ExpandCollapse/ExpandCollapse.js';
import Alert from './Alert.js';
import Icon from './Icon.js';
import Table from './Table.js';
import BlockEmbedExtension from './BlockEmbedExtension.js';

const rendererPlugins = [...ExternalizeLinks, ...RenderInlineCode, ...ListItemNumbering, ...RenderCodeBlock, ...SanitizeHTML, ...StyleLists, ...Table];
const usePlugins = [TableOfContents, BlockEmbed, BlockEmbedExtension, HTMLComments, ExpandCollapse, Alert, Icon];

export { rendererPlugins, usePlugins };
